/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var ArchiveCabinetIcon20Solid = forwardRef('ArchiveCabinetIcon20Solid', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 20 }, props),
        React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M7 2a3 3 0 0 0-3 3v4h12V5a3 3 0 0 0-3-3H7Zm.75 3.75A.75.75 0 0 1 8.5 5h3a.75.75 0 0 1 0 1.5h-3a.75.75 0 0 1-.75-.75Z" }),
        React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M16 10H4v5a3 3 0 0 0 3 3h6a3 3 0 0 0 3-3v-5Zm-7.5 3a.75.75 0 0 0 0 1.5h3a.75.75 0 0 0 0-1.5h-3Z" })));
});
